'use client'

import ActionsMenu from '@/components/actions-menu'
import { RecordKind, useRecordActions } from '@/lib/medical/use-record-actions'
import { MdMoreVert } from 'react-icons/md'

interface Props {
    kind: RecordKind
    id: number
    clientEmail?: string | null
}

/**
 * Dropdown de ações rápidas de um atendimento, para as listas do prontuário.
 *
 * É um componente, e não uma chamada direta ao hook na página, porque a lista
 * renderiza um menu POR LINHA — e hook não se chama dentro de `map`.
 *
 * O clique é contido aqui (`stopPropagation`): nas listas do prontuário o card
 * inteiro navega para o detalhe, e sem isso abrir o menu levaria o médico para
 * outra tela.
 */
export function RecordActionsMenu({ kind, id, clientEmail }: Props) {
    const { actions } = useRecordActions({ kind, id, clientEmail })

    return (
        <div
            onClick={event => {
                event.stopPropagation()
            }}
        >
            <ActionsMenu
                items={actions}
                // Os cards das listas do prontuário têm `overflow-hidden` para
                // arredondar o conteúdo, e isso CORTA um menu `absolute` — daí o
                // portal.
                portal
                trigger={
                    <span
                        className="btn btn-ghost btn-sm btn-square"
                        title="Ações"
                        role="button"
                        tabIndex={0}
                    >
                        <MdMoreVert className="text-lg" />
                    </span>
                }
            />
        </div>
    )
}
